<template>
  <div class="container-fluid">
    <div class="page-title">
      <i class="fa-regular fa-coins"></i>
      <h1>{{ $t("COMMON.RESELLER_PAYMENTS") }}</h1>
    </div>
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">
              {{ $t("RESELLER_PAYMENTS.RESELLER_PAYMENTS_LIST") }}
            </h3>
          </div>
          <div class="col-6 text-right">
            <base-button
              class="elite-button add"
              icon
              size="sm"
              @click="openResellerPaymentCreateModal"
              v-if="$currentUserCan($permissions.PERM_CREATE_RESELLER_PAYMENTS)"
            >
              <span class="btn-inner--icon">
                <i class="far fa-plus-circle"></i>
              </span>
              <span class="btn-inner--text">
                {{ $t("RESELLER_PAYMENTS.ADD_RESELLER_PAYMENT") }}
              </span>
            </base-button>
            <!--<notification-subscription
              v-if="$currentUserCan($permissions.PERM_VIEW_RESELLER_PAYMENTS)"
              :objectType="'reseller-payments'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />-->
          </div>
        </div>
      </div>

      <reseller-payment-list-table
        @onViewResellerPayment="openResellerPaymentViewModal"
        @onEditResellerPayment="openResellerPaymentEditModal"
        @onDeleteResellerPayment="deleteResellerPayment"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewResellerPaymentModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewResellerPaymentModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          v-if="openResellerPayment"
          class="resizable-wrapper-content"
          v-resizable-modal="'RESELLER_PAYMENT'"
          @onCloseModal="closeResellerPaymentModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("RESELLER_PAYMENTS.VIEW") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <notification-subscription
                v-if="openResellerPayment"
                :objectType="'reseller-payments'"
                :objectId="openResellerPayment.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  v-if="openResellerPayment.status == PAYMENT_STATUS_DRAFT"
                  class="edit"
                  @click="openResellerPaymentEditModal(openResellerPayment)"
                >
                  <i class="fal fa-edit"></i>
                  <span>{{ $t("COMMON.EDIT") }}</span>
                </button>
                <button
                  v-if="openResellerPayment.status == PAYMENT_STATUS_DRAFT"
                  class="edit"
                  @click="deleteResellerPayment(openResellerPayment)"
                >
                  <i class="fal fa-trash-alt"></i>
                  <span>{{ $t("COMMON.DELETE") }}</span>
                </button>
              </base-dropdown>
              <button class="close" @click="closeResellerPaymentModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <view-reseller-payment-page
              v-if="openResellerPayment"
              :resellerPaymentId="openResellerPayment.id"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isEditResellerPaymentModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isEditResellerPaymentModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'RESELLER_PAYMENT'"
          @onCloseModal="closeResellerPaymentModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("RESELLER_PAYMENTS.EDIT_RESELLER_PAYMENT") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button
                class="close"
                @click="openResellerPaymentViewModal(openResellerPayment)"
              >
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <edit-reseller-payment-page
              v-if="openResellerPayment"
              :resellerPaymentId="openResellerPayment.id"
              @onViewResellerPayment="openResellerPaymentViewModal"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isAddResellerPaymentModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isAddResellerPaymentModalOpened ? 'show' : 'hide']"
        :key="renderKey * 400"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'RESELLER_PAYMENT'"
          @onCloseModal="closeResellerPaymentModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <h1>
              {{ $t("RESELLER_PAYMENTS.ADD_RESELLER_PAYMENT") }}
            </h1>
            <button class="close" @click="closeResellerPaymentModal(true)">
              <i class="fal fa-times"></i>
            </button>
          </div>
          <div class="resizable-wrapper-content-body">
            <add-reseller-payment-page
              @onViewResellerPayment="openResellerPaymentViewModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Button } from "element-ui";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import { PAYMENT_STATUS_DRAFT } from "@/constants/payments";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import ResellerPaymentListTable from "./partials/ResellerPaymentListTable.vue";
import EditResellerPaymentPage from "./components/EditResellerPaymentComponent.vue";
import AddResellerPaymentPage from "./components/AddResellerPaymentComponent.vue";
import ViewResellerPaymentPage from "./components/ViewResellerPaymentComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ResellerPaymentListTable,
    NotificationSubscription,
    EditResellerPaymentPage,
    AddResellerPaymentPage,
    ViewResellerPaymentPage,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  data() {
    const locationId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewResellerPaymentModalOpened = false;
    let isEditResellerPaymentModalOpened = false;
    let isAddResellerPaymentModalOpened = false;
    let openResellerPayment = null;
    if (locationId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewResellerPaymentModalOpened = true;
      } else if (action === QUERY_ACTIONS_EDIT) {
        isEditResellerPaymentModalOpened = true;
      }
      openResellerPayment = { id: locationId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isAddResellerPaymentModalOpened = true;
    }
    return {
      isViewResellerPaymentModalOpened: isViewResellerPaymentModalOpened,
      isEditResellerPaymentModalOpened: isEditResellerPaymentModalOpened,
      isAddResellerPaymentModalOpened: isAddResellerPaymentModalOpened,
      openResellerPayment: openResellerPayment,
      renderKey: 1,
      PAYMENT_STATUS_DRAFT: PAYMENT_STATUS_DRAFT,
    };
  },

  methods: {
    openResellerPaymentCreateModal() {
      this.closeResellerPaymentModal();
      this.isAddResellerPaymentModalOpened = true;

      this.$router.replace({
        name: "List ResellerPayments",
        query: { action: QUERY_ACTIONS_ADD },
      });
    },
    openResellerPaymentViewModal(resellerpayment, reRender = false) {
      this.closeResellerPaymentModal();
      this.openResellerPayment = resellerpayment;
      this.isViewResellerPaymentModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      this.$router.replace({
        name: "List ResellerPayments",
        query: {
          id: this.openResellerPayment.id,
          action: QUERY_ACTIONS_VIEW,
        },
      });
    },
    openResellerPaymentEditModal(resellerpayment) {
      this.closeResellerPaymentModal();
      this.openResellerPayment = resellerpayment;
      this.isEditResellerPaymentModalOpened = true;

      this.$router.replace({
        name: "List ResellerPayments",
        query: {
          id: this.openResellerPayment.id,
          action: QUERY_ACTIONS_EDIT,
        },
      });
    },
    closeResellerPaymentModal(goBack = false, grid = false) {
      if (goBack && this.$store.getters["routes/previousPathRoute"]) {
        if (grid) {
          this.$store.dispatch("routes/goBackToPreviousGrid");
        } else {
          this.$store.dispatch("routes/goToPreviousPath");
        }
        return;
      }
      this.isAddResellerPaymentModalOpened = false;
      this.isViewResellerPaymentModalOpened = false;
      this.isEditResellerPaymentModalOpened = false;
      this.openResellerPayment = null;

      // if (
      //   this.$route.name !== "List ResellerPayments" ||
      //   JSON.stringify(this.$route.query) !== JSON.stringify({})
      // ) {
      //   this.$router
      //     .replace({
      //       name: "List ResellerPayments",
      //       query: {},
      //     })
      //     .catch((err) => {
      //       if (err.name !== "NavigationDuplicated") {
      //         throw err;
      //       }
      //     });
      // }
    },

    async deleteResellerPayment(resellerPayment) {
      const confirmation = await swal.fire({
        title: this.$t("RESELLER_PAYMENTS.DELETE_THIS_RESELLER_PAYMENT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.isConfirmed) {
          await this.$store.dispatch(
            "resellerPayments/destroy",
            resellerPayment.id
          );
          this.renderKey++;
          this.closeResellerPaymentModal();
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t("RESELLER_PAYMENTS.RESELLER_PAYMENT_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
